function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.57552 4.80147C1.26863 4.48362 0.762176 4.47473 0.444324 4.78162C0.126473 5.08851 0.117588 5.59497 0.424479 5.91282L1.57552 4.80147ZM5.96552 10.5L5.39 11.0557C5.55085 11.2223 5.77601 11.311 6.00727 11.2989C6.23854 11.2868 6.45322 11.1751 6.59583 10.9927L5.96552 10.5ZM13.6303 1.99266C13.9024 1.64455 13.8408 1.14178 13.4927 0.86969C13.1445 0.597604 12.6418 0.659234 12.3697 1.00734L13.6303 1.99266ZM0.424479 5.91282L5.39 11.0557L6.54104 9.94432L1.57552 4.80147L0.424479 5.91282ZM6.59583 10.9927L13.6303 1.99266L12.3697 1.00734L5.33521 10.0073L6.59583 10.9927Z",
  fill: "white"
});

var SvgCompleteIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompleteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/complete-icon.0508060d.svg";
export { ForwardRef as ReactComponent };